import * as React from 'react';
import { Trans } from 'react-i18next';
import { ButtonBase, ButtonProps } from '@mui/material'

export default class CenterButton extends React.Component<ButtonProps> {
	render() {
		return	<ButtonBase style={ {borderRadius: '30px', margin: '3px'} } >
			<div onClick={(e:React.MouseEvent<HTMLElement>) => this.props.onClick(e)} className="action-buttons-icon-circular blue-bg">
				<img src="static/img/icons/center_focus_blue_icon.svg" alt="" width="25" height="25" />
			</div>
		</ButtonBase>
	}
}